import hero from "./project/hero.js";
import products from "./project/products.js";
import works from "./project/works.js";
import about from "./project/about";
hero()
products()
works()
about()

const sweetScroll = new SweetScroll()